import React, { ReactNode } from "react";

import { AppTopNav } from "..";

import styles from "./index.module.css";

/**
 * @description AppBaseLayout の外 (= hoist 済み AppTopNav が無い Provider 上位階層) で
 * エラー / 404 画面を描画する際に、ヘッダー (アカウント設定 = サインアウト動線) を
 * 残すための最小レイアウト。AppTopNav を上部に固定し、残りの領域 (Page404 の
 * .pageNotFound と揃えた中央寄せ snowWhite) に children を流す。
 *
 * AppBaseLayout でラップできない理由: OrganizationProvider 未マウント時の early-return や
 * AppNotifications 等のプロバイダ不在で壊れるため。AppTopNav 自体が参照する context は
 * いずれも app レベルの default で安全に動作する。
 */
export const TopNavOnlyLayout: React.FC<{ children: ReactNode }> = ({
  children,
}) => (
  <div className={styles.root}>
    <AppTopNav showOrganizationMenu />
    <div className={styles.content}>{children}</div>
  </div>
);
